module.exports = __webpack_public_path__ + "media/12.21c0c0c0.aac";